import { call, put, takeLatest } from 'redux-saga/effects';
import { request } from 'utils/request';
import { generateEmailActions } from './slice';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';
import { header, getUUIDToken } from 'utils/auth';

export function* getInventory({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/superuser/dealer_inventories_by_algorithm`;
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),
      body: JSON.stringify(payload.data)
    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestInventoryError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Failed to retrieve inventory',
        }),
      );
    }

    yield put(generateEmailActions.requestInventorySuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(generateEmailActions.requestInventoryError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(generateEmailActions.requestInventoryError(err.response));
    } else {
      yield put(generateEmailActions.requestInventoryError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Failed to retrieve inventory',
      }),
    );
  }
}

export function* compileTemplate({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/templates/dynamicTemplates/compile`;
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),
      body: JSON.stringify(payload.data)
    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestCompileTemplateError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Failed to compile template',
        }),
      );
    }

    yield put(generateEmailActions.requestCompileTemplateSuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(generateEmailActions.requestCompileTemplateError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(generateEmailActions.requestCompileTemplateError(err.response));
    } else {
      yield put(generateEmailActions.requestCompileTemplateError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Failed to compile template',
      }),
    );
  }
}

export function* uploadFiles({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/content/uploadImage`;
    console.log(payload.body);
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        Authorization: header(),
      }),
      body: payload.body,
    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestUploadFileError(response));
      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Error uploading image',
        }),
      );
    }
    yield put(generateEmailActions.requestUploadFileSuccess(response));
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Image uploaded',
      }),
    );
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(
        generateEmailActions.requestUploadFileError(err.response),
      );
    } else if (err.message === 'Server Error') {
      yield put(
        generateEmailActions.requestUploadFileError(err.response),
      );
    } else {
      yield put(generateEmailActions.requestUploadFileError(err));
    }
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Error uploading image',
      }),
    );
  }
}

export function* getTemplates({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/templates/dynamicTemplates?dealer_id=${payload.dealer_id}${payload.category?.length ? `&category=${payload.category}` : ""}${payload.sub_category?.length ? `&sub_category=${payload.sub_category}` : ""}${payload.segments?.length ? `&segments=${payload.segments}` : ""}`;
    const response = yield call(request, requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),

    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestTemplatesError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Failed to retrieve templates',
        }),
      );
    }

    yield put(generateEmailActions.requestTemplatesSuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(generateEmailActions.requestTemplatesError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(generateEmailActions.requestTemplatesError(err.response));
    } else {
      yield put(generateEmailActions.requestTemplatesError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Failed to retrieve templates',
      }),
    );
  }
}

export function* getCategories({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/templates/dynamicTemplates/categories?dealer_id=${payload.dealer_id}`;
    const response = yield call(request, requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),

    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestCategoriesError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Failed to retrieve categories',
        }),
      );
    }

    yield put(generateEmailActions.requestCategoriesSuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(generateEmailActions.requestCategoriesError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(generateEmailActions.requestCategoriesError(err.response));
    } else {
      yield put(generateEmailActions.requestCategoriesError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Failed to retrieve categories',
      }),
    );
  }
}

export function* getSubCategories({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/templates/dynamicTemplates/subCategories?dealer_id=${payload.dealer_id}&category=${payload.category}`;
    const response = yield call(request, requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),

    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestSubCategoriesError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Failed to retrieve sub-categories',
        }),
      );
    }

    yield put(generateEmailActions.requestSubCategoriesSuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(generateEmailActions.requestSubCategoriesError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(generateEmailActions.requestSubCategoriesError(err.response));
    } else {
      yield put(generateEmailActions.requestSubCategoriesError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Failed to retrieve sub-categories',
      }),
    );
  }
}

export function* getSegments({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/templates/dynamicTemplates/segments?dealer_id=${payload.dealer_id}&category=${payload.category}&sub_category=${payload.sub_category}`;
    const response = yield call(request, requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),

    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestSegmentsError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Failed to retrieve segments',
        }),
      );
    }

    yield put(generateEmailActions.requestSegmentsSuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(generateEmailActions.requestSegmentsError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(generateEmailActions.requestSegmentsError(err.response));
    } else {
      yield put(generateEmailActions.requestSegmentsError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Failed to retrieve segments',
      }),
    );
  }
}

export function* getAlgorithm({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v1/templates/getAlgorithms?dealer_id=${payload.dealer_id}&rule_name=COMMON_ALGORITHM`;
    const response = yield call(request, requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
        'uuid-token': getUUIDToken(),
      }),

    });

    if (response.statusCode === 500) {
      yield put(generateEmailActions.requestAlgorithmError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Failed to retrieve inventory filter options',
        }),
      );
    }

    yield put(generateEmailActions.requestAlgorithmSuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(generateEmailActions.requestAlgorithmError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(generateEmailActions.requestAlgorithmError(err.response));
    } else {
      yield put(generateEmailActions.requestAlgorithmError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Failed to retrieve inventory filter options',
      }),
    );
  }
}

export function* generateEmailSaga() {
  yield takeLatest(generateEmailActions.requestInventory.type, getInventory);
  yield takeLatest(generateEmailActions.requestCompileTemplate.type, compileTemplate);
  yield takeLatest(generateEmailActions.requestUploadFile.type, uploadFiles);
  yield takeLatest(generateEmailActions.requestTemplates.type, getTemplates);
  yield takeLatest(generateEmailActions.requestCategories.type, getCategories);
  yield takeLatest(generateEmailActions.requestSubCategories.type, getSubCategories);
  yield takeLatest(generateEmailActions.requestSegments.type, getSegments);
  yield takeLatest(generateEmailActions.requestAlgorithm.type, getAlgorithm);
}
